export default {
  toggleSelected(state, brochure) {
    brochure.selected = !brochure.selected;
  },
  changeState(state) {
    state.isForm = !state.isForm;
  },
  setData(state, data) {
    state.data = {
      ...data
    };
  },
  setBrochureData(state, brochureData) {
    state.brochures = brochureData.map(brochure => ({
      ...brochure,
      selected: false
    }));
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setApiError(state, apiError) {
    state.data.apiError = apiError;
  },
  setApiErrorMessage(state, errorMessage) {
    state.data.errorMessage = errorMessage;
  }
}